'use client'

import * as CollapsiblePrimitive from '@radix-ui/react-collapsible'
import { ChevronDown } from 'lucide-react'

import { CLRenderable } from '~/components/component-library/types'
import { cn } from '~/utils/tailwind-utils'

export const CollapsibleTrigger = ({
  children,
  className,
}: {
  children: CLRenderable
  className?: string
}) => (
  <CollapsiblePrimitive.CollapsibleTrigger
    className={cn(
      'flex items-center focus:outline-none [&>svg]:data-[state=open]:-rotate-180',
      className || 'text-xs text-secondary',
    )}
  >
    {children}
    <ChevronDown className="ml-0.5 h-3.5 w-3.5 rotate-0 transition" />
  </CollapsiblePrimitive.CollapsibleTrigger>
)
